// Core React Imports
import React from "react";

// Local Imports
import { DivColumn, ParagraphText } from "../../../styles/SharedStyles";
import ConstantsTexts from "../../../constants/ConstantsTexts";
import WidgetInputBase from "../widget-input-base/WidgetInputBase";

// CSS/Stylesheets
import "./WidgetInputsFromTo.css";

const WidgetInputsFromTo = ({ valueFromInput, valueToInput, onChangeFromInput, onChangeToInput, disabled = false }) => {
  return (
    <DivColumn className="model-2-frame-20">
      <div className="model-2-frame-21">
        <DivColumn className="model-2-frame-22">
          <div className="model-2-frame-23">
            <DivColumn className="model-2-frame-24">
              <ParagraphText className="model-text-7">{ConstantsTexts.CODE_66}</ParagraphText>
              <WidgetInputBase value={valueFromInput} onChange={onChangeFromInput} disabled={disabled} />
            </DivColumn>
          </div>
        </DivColumn>
        <DivColumn className="model-2-frame-25">
          <div className="model-2-frame-26">
            <DivColumn className="model-2-frame-24">
              <ParagraphText className="model-text-7">{ConstantsTexts.CODE_67}</ParagraphText>
              <WidgetInputBase value={valueToInput} onChange={onChangeToInput} disabled={disabled} />
            </DivColumn>
          </div>
        </DivColumn>
      </div>
    </DivColumn>
  );
};

export default WidgetInputsFromTo;
